

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// customerLogin
// CUSTOMERLOGIN
const CUSTOMERLOGIN= createAsyncThunk(
  "customerLogin/customerLogin",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const customerLoginSlice = createSlice({
  name: "customerLoginSlice",
  initialState: {
    customerLogin: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcustomerLogin: (state) => {
        state.customerLogin.loading = false
        state.customerLogin.error = false
        state.customerLogin.data = []
        state.customerLogin.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CUSTOMERLOGIN.fulfilled, (state, action) => {
      state.customerLogin = {
        ...state.customerLogin,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CUSTOMERLOGIN.pending, (state, action) => {
      state.customerLogin = {
        ...state.customerLogin,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CUSTOMERLOGIN.rejected, (state, action) => {
      state.customerLogin = {
        ...state.customerLogin,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const customerLoginAction = {
    CUSTOMERLOGIN,
};

export { customerLoginAction };
export default customerLoginSlice.reducer;
export const {setInitialStateOfcustomerLogin} = customerLoginSlice.actions